import { FormMediaSelectModal } from '@form-builder/components/Media/FormMediaSelect/FormMediaSelectModal'

import { Editor } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { Image as ImageIcon } from 'iconsax-react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import type { Media } from '@form-builder/types'

type Props = {
  editor: Editor
}

export const ImageButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(false)

  const onMediaSelect = (media: Media) => {
    if (media.url) {
      editor
        .chain()
        .focus()
        .setImage({
          src: media.url,
          alt: media.name || 'Image',
          width: media.width,
          height: media.height
        })
        .run()
    }
    setIsOpen(false)
  }

  return (
    <>
      <Tooltip title={t('editor.image')}>
        <Button
          icon={<ImageIcon size={14} />}
          onClick={() => setIsOpen(true)}
        />
      </Tooltip>

      {isOpen && (
        <FormMediaSelectModal
          open={isOpen}
          contentType="image"
          onOk={onMediaSelect}
          onCancel={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
